var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCountryFlagMalaysiasvgrIcon = function SvgCountryFlagMalaysiasvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#country-flag-malaysia_svgrIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#country-flag-malaysia_svgrIcon_svg__b)",
    d: "M0 0h32v32H0z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "country-flag-malaysia_svgrIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "country-flag-malaysia_svgrIcon_svg__b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#country-flag-malaysia_svgrIcon_svg__c",
    transform: "scale(.02083)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA2JJREFUaEPtWLFPGmEUf9dBF0hJnHARh+Jk2kqnLp4d7AKh2gkXtElx1ATnnvwDtR2piUAHnZpIuVmOoXao2Da2gwwqC0waDSzapDS/j3IFesfF8zvJJfdGvu993/u933u/9x2CQLEG9cG+0DqXWwUHgMk8Hs3/MunZ6dY3Bn43krcLwOO+JI/ris7rA3ReG7zx5bcCwDdco6XIAT0TyzTiralBfysNUaHopawySkrRawqM5QAQ+Fr8sxpcOuenjDzGAm8ZWOlmQ+s3LYSWqlBqVaFosMTuPam4aWZlmr6XhnQzfd9/qq5LsSIl3gXY3slAhQrFYU0/ywBIsT2SYvtq8FOLQSpX3T3LBEFvKz4SqEGvYvs0uzJNa/FderM5rutriQqh5o8+bqnBTi2GOkqmG0VYPGZ9gEynJIUS6wGSXu5TYn2CliI/aWJulnAmGMoqvg53S3qgvXSQUWSyl7UCf7s1TmAB5nFf0XltgDFyUR+gyUCVniwG/+sVSwAc5TbJ562zQBZWRcrIfkOFiYYOKSUVNPehf/RKkDsAqMdZPqMG8nDuuW7joiyQ8fBkmWW5XWLbkYCJi/ogHVfcrIQy8j2VCe5N3F3/dx7FDLMP0JDalmJpOegxyR1ANwOjoYiugmBva8ChQY0MM+S9PNYx9CxRobN8mjUhbGblKWWVEc3YAOCuq7kP+79uftDch4k9E/8nBILQnCsw7j2AQ6HdS5Ef7AJk7UVC7JlclN1OUmZ7lyMHKng4QYUAFAFrnWMJAMhiPimrQRuVUVgsM5Ye+E9pQypQWm4CwSTGGuQzLJ6Qx3XJniHtZgkAXPA6vkvLf1lACWhpeDctYG5bGaVy1cWAwGcnmWNzRO/lyr2JW0GBdpQFsgpr1XGv50T7mwfNjcGGc0a8dV0ptgxAszE75fGk4mJlkS34DL8FMBOM3k64wxIV6i6NaKhE0eAhiYGquoTXJQYUvgPwQlV0XptG0mpZD2hdDEba9R6B3/Sr7FYBGGXTzLrtAVjaxGYyel0f2wPgpkLp1Ke+/LUYnX98XdI09wuNRqMvALhET0T2B7BHgr0ZsD2A4/kFezPgNDEvOTF5jqNCJhPHzU1wVIhbLs0dZP8ecGTUHPPcvOzfxI4KcSsGcwc5KmQub/y8bM/AH7Ea2JiP/ULKAAAAAElFTkSuQmCC",
    id: "country-flag-malaysia_svgrIcon_svg__c",
    width: 48,
    height: 48
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCountryFlagMalaysiasvgrIcon);
export default ForwardRef;